import LabeledToggle from 'scoreboard/components/labeled-toggle'

function periodReferenceTypeToggle({ value } = {}) {
	return new LabeledToggle({
		value,
		options: [{
			value: 'relative',
			label: 'report.customReport.relative'
		},{
			value: 'by-date',
			label: 'report.customReport.byDate'
		}]
	})
}

export default periodReferenceTypeToggle

periodReferenceTypeToggle.__filename__ = 'components/period-reference-type-toggle.js'
